import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { DialogActions, DialogStateModel } from '@app/_store';
import { ConfirmDialogService } from '@app/_services';

const defaults = {
  title: '',
  type: '',
  body: '',
  confirmText: undefined,
  critical: false,
  onConfirm: () => of(null),
  onCancel: () => of(null),
};

@State<DialogStateModel>({
  name: 'dialogs',
  defaults,
})
@Injectable()
export class DialogState {
  constructor(private confirmDialogService: ConfirmDialogService) {}

  @Selector()
  static getCurrent(state: DialogStateModel): DialogStateModel {
    return state;
  }

  @Action(DialogActions.Confirm)
  confirm({ patchState }: StateContext<DialogStateModel>, action: DialogActions.Confirm): Observable<void> {
    patchState({
      title: action.title,
      body: action.body,
      type: 'confirm',
      critical: action.critical ?? false,
      confirmText: action.confirmText,
      onConfirm: action.onConfirm,
      onCancel: action.allowCancel
        ? () => {
            return of(null);
          }
        : undefined,
    });
    this.confirmDialogService.confirm();
    return of(null);
  }
}
